<template>
  <v-navigation-drawer app :model-value="modelValue" :permanent="!navType" :temporary="navType">
    <v-divider></v-divider>
    <v-list dense nav subheader class="pa-0">
      <div v-for="item in navList" :key="item.title">
        <div color="primary" mandatory>
          <v-list-item :to="{ name: item.routeName }" color="primary" rounded="0" @click="itemClicked">
            <div>
              <v-list-item-title class="pl-2">
                {{ item.title }}
              </v-list-item-title>
            </div>
          </v-list-item>
        </div>
        <v-divider v-if="item.divider"></v-divider>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import filterNav from '@/composables/filterList'
import nav from '@/assets/main-nav.json'
import { useDisplay } from 'vuetify'

export default defineComponent({
  name: 'NavSidebar',
  props: ['modelValue', 'navType'],
  setup(props, { emit }) {
    let resources = localStorage.getItem('resources')
    let navList = filterNav(nav, resources)
    const { smAndUp } = useDisplay()

    const itemClicked = () => {
      if (!smAndUp.value) {
        emit('update:modelValue', !props.modelValue)
      }
    }
    return { navList, itemClicked }
  },
})
</script>
